import { render, staticRenderFns } from "./HeaderFeedback.vue?vue&type=template&id=72021e34&scoped=true&"
import script from "./HeaderFeedback.vue?vue&type=script&lang=js&"
export * from "./HeaderFeedback.vue?vue&type=script&lang=js&"
import style0 from "./HeaderFeedback.vue?vue&type=style&index=0&id=72021e34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72021e34",
  null
  
)

component.options.__file = "HeaderFeedback.vue"
export default component.exports